import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Link } from 'react-router';
import { ForgotPasswordForm } from '@/components/forms/forgot-password';

export const ForgotPasswordPage = () => {
  useLocale();

  return (
    <div className="w-screen max-w-lg px-4">
      <div className="w-full">
        <h1 className="font-semibold text-3xl">{t('auth.forgotYourPassword')}</h1>
        <p className="mt-2 text-muted-foreground text-sm">
          {t('auth.noWorriesItHappensEnterYourEmailAndWe')}{' '}
        </p>
        <ForgotPasswordForm className="mt-4" />
        <p className="mt-6 text-center text-muted-foreground text-sm">
          {t('auth.rememberedYourPassword')}{' '}
          <Link className="text-primary duration-200 hover:opacity-70" to="/signin">
            {t('auth.signIn')}{' '}
          </Link>
        </p>
      </div>
    </div>
  );
};
